import React, { useContext, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { AppContext } from '../context/AppContext';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiChevronDown, FiChevronUp, FiBookOpen } = FiIcons;

const RuleCard = ({ rule, index }) => {
  const [isOpen, setIsOpen] = useState(false);
  const isOdd = index % 2 !== 0;
  const accentColorClass = isOdd ? 'text-nba-red' : 'text-nba-blue';
  const borderClass = isOdd ? 'border-l-nba-red' : 'border-l-nba-blue';
  const hoverBgClass = isOdd ? 'hover:bg-nba-red/5' : 'hover:bg-nba-blue/5';

  return (
    <div className="w-full mt-4">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`w-full flex items-center justify-between p-6 bg-nba-card border border-white/5 ${hoverBgClass} border-l-4 ${borderClass} transition-colors group outline-none`}
      >
        <div className="flex items-center gap-5 text-left">
          <SafeIcon icon={FiBookOpen} className={`text-3xl opacity-50 group-hover:opacity-100 transition-opacity shrink-0 ${accentColorClass}`} />
          <h3 className="font-league uppercase italic tracking-tight text-3xl sm:text-4xl text-white group-hover:text-white/80 transition-colors m-0 leading-none">
            {rule.title}
          </h3>
        </div>
        <SafeIcon icon={isOpen ? FiChevronUp : FiChevronDown} className="text-3xl text-white/40 group-hover:text-white transition-colors shrink-0 ml-4" />
      </button>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="overflow-hidden bg-black/20 border-x border-b border-white/5"
          >
            <div className="p-6 md:p-8 text-white/70 text-lg leading-relaxed whitespace-pre-wrap font-body">
              {rule.description}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

const Rules = () => {
  const { rules, textStyles } = useContext(AppContext);

  return (
    <div className="py-12 space-y-10 max-w-5xl mx-auto px-4 min-h-[75vh]">
      <div className="border-b-4 border-white pb-6 space-y-6">
        <h1 className="font-league italic leading-none tracking-tighter uppercase dyn-rulesTitle">
          {textStyles.rulesTitle?.text || 'REGOLAMENTO'}
        </h1>
      </div>

      <div className="space-y-2">
        {rules.length > 0 ? (
          rules.map((rule, idx) => (
            <RuleCard key={rule.id} rule={rule} index={idx} />
          ))
        ) : (
          <div className="py-20 text-center text-white/20 font-league text-4xl uppercase italic">
            Nessun regolamento inserito.
          </div>
        )}
      </div>
    </div>
  );
};

export default Rules;